module.exports = __webpack_public_path__ + "static/media/ic_calendar2-black.2080e509.svg";